import { CANDY_APPLE_LIGHT, CALYPSO_LIGHT, KOALA, LORAX_LIGHT, MARIGOLD_LIGHT, NORMAN_LIGHT, OZ_LIGHT, SORBET_LIGHT, THUNDERDOME_LIGHT } from 'HubStyleTokens/colors';
export default {
  'candy-apple': CANDY_APPLE_LIGHT,
  calypso: CALYPSO_LIGHT,
  koala: KOALA,
  lorax: LORAX_LIGHT,
  marigold: MARIGOLD_LIGHT,
  norman: NORMAN_LIGHT,
  oz: OZ_LIGHT,
  sorbet: SORBET_LIGHT,
  thunderdome: THUNDERDOME_LIGHT
};